import { useAuth0 } from '@auth0/auth0-react'
import { Button } from '@mui/material'

const LoginButton = () => {
  const { loginWithRedirect } = useAuth0()

  return (
    <Button
      data-cy="login-button"
      variant="contained"
      onClick={() => {
        loginWithRedirect({ appState: { target: 'redirectURL' } })
      }}
    >
      Log In
    </Button>
  )
}

export default LoginButton
